import type { OnChangeValue, Option, SingleValue } from '@ksyos/design-system';
import { Select } from '@ksyos/design-system';
import { getCountryOptions } from '@frontend/utils/countriesUtils';
import { getSelectedLanguage } from '../../translate';

type CountrySelectProps = {
    error?: string;
    onChange: (value: string | null) => void;
    onDoValidate?: (value: string | null) => void;
    value: string | null; // 2 letter country code ISO 3166-1 alpha-2
};

export function CountrySelect({ error, onChange, onDoValidate, value }: CountrySelectProps) {
    const translate = getSelectedLanguage();
    const countriesList = getCountryOptions();
    const selectedOption = countriesList.find((country) => country.value === value?.toUpperCase());

    return (
        countriesList.length && (
            <Select
                error={error}
                onChange={(option: OnChangeValue<Option, false>) => {
                    if (option) {
                        handleChange(option.value);
                    }
                }}
                options={countriesList}
                placeholder={translate.common.country}
                value={selectedOption}
            />
        )
    );

    function handleChange(newValue: SingleValue<string>) {
        onChange(newValue);
        onDoValidate?.(newValue);
    }
}
